import { useTranslation } from "react-i18next"

import { Lightbulb } from "@/components/icons"
import { cn } from "@/lib/utils"

interface ChatHistoryItemTitleIndicatorProps {
  pending_title_suggestion?: {
    suggested_title: string
    reason: string
    confidence: number
    theme?: string
  }
}

export function ChatHistoryItemTitleIndicator({
  pending_title_suggestion,
}: ChatHistoryItemTitleIndicatorProps) {
  const { t } = useTranslation()

  if (!pending_title_suggestion) {
    return null
  }

  return (
    <span
      role="img"
      aria-label={t("dynamic_titles.generic_indicator_tooltip", {
        defaultValue: "This title can be improved",
      })}
      className={cn(
        "ml-1 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-sm",
        "ring-1",
        "bg-primary/10 text-primary ring-primary/50 animate-pulse"
      )}
    >
      <Lightbulb className="h-3.5 w-3.5" />
    </span>
  )
}
